import { BankSession, FetchBankSessionsTransactionsResponseDto } from '#modules/Bank/Bank.types'
import { connection } from '#modules/Bank/Redux/connectionMiddleware'
import { trackingService } from '@monthio/react-components'

export const api = {
	createBankSession: async (
		bankId: number,
		consentCode: string,
		authUrl?: string,
	): Promise<BankSession> => {
		try {
			return await connection.invoke('CreateBankSession', {
				bankId,
				consentCode,
				authUrl,
			})
		} catch (err) {
			trackingService.trackTechnicalEvent(err as any, 'createBankSession', {
				source: 'transactionClientApp',
			})
			throw err
		}
	},
	fetchBankSessionsTransactions: (
		deselectedByUserAccountIds: string[],
		calculationReferenceDate?: Date,
	): Promise<FetchBankSessionsTransactionsResponseDto> => {
		try {
			return connection.invoke('FetchBankSessionsTransactions', {
				DeselectedByUserAccountIds: deselectedByUserAccountIds,
				CalculationReferenceDate: calculationReferenceDate,
			})
		} catch (err) {
			trackingService.trackError(err as any, 'fetchBankSessionsTransactions', {
				source: 'transactionClientApp',
			})
			throw err
		}
	},
	closeConsumerDataPullSession: async (
		shouldClearBudgetAndDebtData: boolean,
	): Promise<void> => {
		try {
			await connection.invoke(
				'CloseConsumerDataPullSession',
				shouldClearBudgetAndDebtData,
			)
		} catch (err) {
			trackingService.trackError(err as any, 'closeConsumerDataPullSession', {
				source: 'transactionClientApp',
			})

			throw err
		}
	},
}
